export function contentHasErrored(state = false, action) {
    switch (action.type) {
        case 'CONTENT_HAS_ERRORED':
            return action.contentHasErrored;

        default:
            return state;
    }
}

export function contentIsLoading(state = false, action) {
    switch (action.type) {
        case 'CONTENT_IS_LOADING':
            return action.contentIsLoading;

        default:
            return state;
    }
}

export function content(state = {}, action) {
    switch (action.type) {
        case 'CONTENT_FETCH_SUCCESS':
            return action.content;

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/content.js